export default "__VITE_ASSET__0c7UWe$E__"